import { render, staticRenderFns } from "./materialList.vue?vue&type=template&id=57da197a&scoped=true"
import script from "./materialList.vue?vue&type=script&lang=js"
export * from "./materialList.vue?vue&type=script&lang=js"
import style0 from "./materialList.vue?vue&type=style&index=0&id=57da197a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57da197a",
  null
  
)

export default component.exports